import { combineReducers } from "redux";
import authReducer from "../../features/auth/authReducer";
import eventReducer from "../../features/events/eventReducer";
import lobbyReducer from "../../features/lobby/lobbyReducer";
import profileReducer from "../../features/profiles/profileReducer";
import testReducer from "../../features/sandbox/testReducer";
import QuizReducer from "../../features/selectors/quiz/QuizReducer";
import asyncReducer from "../async/asyncReducer";
import modalReducer from "../common/modals/modalReducer";
import { connectRouter } from "connected-react-router";

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    test: testReducer,
    event: eventReducer,
    lobby: lobbyReducer,
    modals: modalReducer,
    auth: authReducer,
    async: asyncReducer,
    profile: profileReducer,
    quiz: QuizReducer,
  });

export default rootReducer;
